import { IdentityAccount } from './identityAccount'

export interface MediaFile {
  gid: string
  url: string
  contentType: string
}

enum EarSide {
  LEFT = 'LEFT',
  RIGHT = 'RIGHT',
}

interface Otoscopy {
  gid: string
  customerGid: string
  opportunityGid: string
  earSide: EarSide
  countryCode: string
  mediaFiles?: MediaFile[]
  assessment?: OtoscopyAssessment
  hasMediaFiles: boolean
  isAssessed: boolean
  isHearingAidFittingPermitted: string
  createdBy: IdentityAccount
  updatedBy: IdentityAccount
  createdAt: string
  updatedAt: string
}

interface OtoscopyAssessment {
  gid: string
  otoscopyGid: string
  isEardrumViewObstructed: 'YES' | 'NO'
  eardrumViewObstructionReasons: string[]
  eardrumViewObstructionReasonsDetails: string
  areEarAbnormalitiesPresent: 'YES' | 'NO'
  earAbnormalities: string[]
  earAbnormalitiesDetails: string
  isHearingAidFittingPermitted: string
  isValidatedByHearingCareProfessional: boolean
  validatedBy: IdentityAccount
  validatedAt: string
  createdBy: IdentityAccount
  updatedBy: IdentityAccount
  createdAt: string
  updatedAt: string
}

export type { Otoscopy, OtoscopyAssessment }
export { EarSide }
